import React, { useEffect, useState } from 'react'
import { Button, InputGroup, FormControl, Modal } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import Navbars from '../../../Components/Navbar'
import firebaseConfig from '../../../Utilities/Firebase'
import { getDatabase, ref, set, onValue } from 'firebase/database'
import { initializeApp } from 'firebase/app'
import { useNavigate } from 'react-router'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import moment from 'moment'
import { getAcceptedEntriesDataExcel, getNotCollectedEntriesDataExcel } from '../../../Utilities'
import FileUploader from './UploadButton'

const FirebaseApp = initializeApp(firebaseConfig)
const db = getDatabase(FirebaseApp)
const RCAccept = () => {
  const [pendingData, setPendingData] = useState([])
  const [acceptedData, setAcceptedData] = useState([])
  const [notCollectedData, setNotCollectedData] = useState([])
  const [modalEntry, setModalEntry] = useState({})
  const [modalMessage, setModalMessage] = useState('')
  const [filterText1, setFilterText1] = useState('')
  const [filterText2, setFilterText2] = useState('')
  const [filterText3, setFilterText3] = useState('')

  const filteredPendingData = pendingData.filter(entry => {
    const values = Object.values(entry).map(item => item.toString().toLowerCase())
    return values.some(field => field.includes(filterText1.toLowerCase()))
  })

  const filteredAcceptedData = acceptedData.filter(entry => {
    const values = Object.values(entry).map(item => item.toString().toLowerCase())
    return values.some(field => field.includes(filterText2.toLowerCase()))
  })

  const filteredNotCollectedData = notCollectedData.filter(entry => {
    const values = Object.values(entry).map(item => item.toString().toLowerCase())
    return values.some(field => field.includes(filterText3.toLowerCase()))
  })

  const navigate = useNavigate()

  useEffect(() => {
    IsUserLogedIn()

    const railwayPendingRef = ref(db, 'railway_pending/')

    onValue(railwayPendingRef, snapshot => {
      const data = snapshot.val()
      const transformed = Object.keys(data).map(key => ({
        ...data[key],
        SequenceNo: data[key]['SequenceNo'] ?? 0,
        firebaseKey: key,
      }))
      // Sorting the data sequence wise initially
      transformed.sort((a, b) => a.SequenceNo - b.SequenceNo)
      setPendingData(transformed)
    })

    const railwayAcceptedRef = ref(db, 'railway_accepted/')
    onValue(railwayAcceptedRef, snapshot => {
      const data = snapshot.val()
      const transformed = Object.keys(data).map(key => ({
        ...data[key],
        SequenceNo: data[key]['SequenceNo'] ?? 0,
        firebaseKey: key,
      }))
      transformed.sort((a, b) => a.SequenceNo - b.SequenceNo)
      setAcceptedData(transformed)
    })

    const railwayNotCollectedRef = ref(db, 'railway_notcollected/');
    onValue(railwayNotCollectedRef, snapshot => {
      const data = snapshot.val()
      if(data == null){
        setNotCollectedData([])
        return
      }
      const transformed = Object.keys(data).map(key => ({
        ...data[key],
        firebaseKey: key,
      }))
      setNotCollectedData(transformed)
    });

    // UNCOMMENT AND RELOAD PAGE FEW TIMES O CREATE FAKE ENTRIES
    // const makeEntry = () => ({
    //   SAP: faker.datatype.uuid(),
    //   Name: faker.name.findName(),
    //   From: faker.lorem.word(),
    //   Address: faker.address.streetAddress(),
    //   Contact: faker.datatype.number(),
    //   Class: faker.datatype.number(),
    //   DOM: faker.datatype.datetime(),
    //   Age: faker.datatype.number(),
    //   Year: faker.datatype.number(),
    //   Department: faker.lorem.word(),
    //   Date: faker.datatype.datetime(),
    //   Status: faker.lorem.word(),
    //   Reason: faker.lorem.sentence(),
    // });
    // for (let i = 0; i < 20; ++i) {
    //   const newKey = push(child(ref(db), "railway_pending/")).key;
    //   set(ref(db, "railway_pending/" + newKey), makeEntry());
    // }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function IsUserLogedIn() {
    const FirebaseApp = initializeApp(firebaseConfig)
    const auth = getAuth(FirebaseApp)
    onAuthStateChanged(auth, user => {
      if (user === null) {
        navigate('/')
      }
    })
  }
  const pendingColumns = [
    {
      name: 'SequenceNo',
      wrap: true,
      sortable: true,
      selector: item => item['SequenceNo'],
    },
    {
      name: 'SAP',
      wrap: true,
      sortable: true,
      selector: item => item['SAP'],
    },
    {
      name: 'Name',
      wrap: true,
      sortable: true,
      selector: item => item['Name'],
    },
    {
      name: 'From',
      wrap: true,
      sortable: true,
      selector: item => item['From'],
    },
    {
      name: 'Address',
      wrap: true,
      sortable: true,
      selector: item => item['Address'],
    },
    {
      name: 'Contact',
      wrap: true,
      sortable: true,
      selector: item => item['Contact'],
    },
    {
      name: 'Class',
      wrap: true,
      sortable: true,
      selector: item => item['Class'],
    },
    {
      name: 'DOB',
      wrap: true,
      sortable: true,
      selector: item => moment(item['DOB']).format('Do MMMM YYYY'),
    },
    {
      name: 'Age',
      wrap: true,
      sortable: true,
      selector: item =>
        moment.duration(moment().diff(item['DOB'])).years() +
        ' Years ' +
        moment.duration(moment().diff(item['DOB'])).months().toString() +
        ' Months',
    },
    {
      name: 'Year',
      wrap: true,
      sortable: true,
      selector: item => item['Year'],
    },
    {
      name: 'Department',
      wrap: true,
      sortable: true,
      selector: item => item['Department'],
    },
    {
      name: 'Date',
      wrap: true,
      sortable: true,
      type: 'date',
      sortFunction: (a, b) => {
        // data eg - 24-05-2021
        const dateA = moment(a['Date'], 'DD-MM-YYYY')
        const dateB = moment(b['Date'], 'DD-MM-YYYY')
        if (dateA.isBefore(dateB)) {
          return -1
        }
        if (dateA.isAfter(dateB)) {
          return 1
        }
        return 0
      },
      selector: item => item['Date'],
    },
    {
      name: 'Actions',
      wrap: true,
      cell: row => (
        <Button
          size="sm"
          variant="outline-dark"
          onClick={() => {
            setModalEntry(row)
          }}
        >
          Actions
        </Button>
      ),
    },
    {
      name: 'Status',
      wrap: true,
      sortable: true,
      selector: item => item['Status'],
    },
    {
      name: 'Reasons',
      wrap: true,
      sortable: true,
      selector: item => item['Reasons'],
    },
    {
      name: 'Gender',
      wrap: true,
      sortable: true,
      selector: item => item['Gender'] ?? '',
    },
  ]

  const acceptedColumns = [
    {
      name: 'SequenceNo',
      wrap: true,
      sortable: true,
      selector: item => item['SequenceNo'],
    },
    {
      name: 'SAP',
      wrap: true,
      sortable: true,
      selector: item => item['SAP'],
    },
    {
      name: 'Name',
      wrap: true,
      sortable: true,
      selector: item => item['Name'],
    },
    {
      name: 'From',
      wrap: true,
      sortable: true,
      selector: item => item['From'],
    },
    {
      name: 'Address',
      wrap: true,
      sortable: true,
      selector: item => item['Address'],
    },
    {
      name: 'Contact',
      wrap: true,
      sortable: true,
      selector: item => item['Contact'],
    },
    {
      name: 'Class',
      wrap: true,
      sortable: true,
      selector: item => item['Class'],
    },
    {
      name: 'DOB',
      wrap: true,
      sortable: true,
      selector: item => moment(item['DOB']).format('Do MMMM YYYY'),
    },
    {
      name: 'Age',
      wrap: true,
      sortable: true,
      selector: item =>
        moment.duration(moment().diff(item['DOB'])).years() +
        ' Years ' +
        moment.duration(moment().diff(item['DOB'])).months().toString() +
        ' Months',
    },
    {
      name: 'Year',
      wrap: true,
      sortable: true,
      selector: item => item['Year'],
    },
    {
      name: 'Department',
      wrap: true,
      sortable: true,
      selector: item => item['Department'],
    },
    {
      name: 'Date',
      wrap: true,
      sortable: true,
      selector: item => item['Date'],
    },
    {
      name: 'Message',
      wrap: true,
      sortable: true,
      selector: item => item['Message'],
    },
    {
      name: 'Edit',
      wrap: true,
      cell: row => (
        <Button
          size="sm"
          variant="outline-info"
          onClick={() => {
            setModalEntry({ ...row, isEditingMessage: true })
            setModalMessage(row.Message)
          }}
        >
          Edit
        </Button>
      ),
    },
    {
      name: 'Delete',
      wrap: true,
      cell: row => (
        <Button
          size="sm"
          variant="outline-danger"
          onClick={() => {
            set(ref(db, 'railway_accepted/' + row.firebaseKey), null)
          }}
        >
          Delete
        </Button>
      ),
    },
    {
      name: 'Status',
      wrap: true,
      sortable: true,
      selector: item => item['Status'],
    },
    {
      name: 'Reasons',
      wrap: true,
      sortable: true,
      selector: item => item['Reasons'],
    },
    {
      name: 'Gender',
      wrap: true,
      sortable: true,
      selector: item => item['Gender'] ?? '',
    },
    {
      name: 'CollectedAt',
      wrap: true,
      sortable: true,
      selector: item => (item['CollectedAt'] ? moment(item['CollectedAt']).format('DD MMM YYYY hh:mm a') : ''),
    },
  ]

  const notCollectedColumns = [
    {
      name: 'Sr No',
      wrap: true,
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: 'SAP',
      wrap: true,
      sortable: true,
      selector: item => item['SAP'],
    },
    {
      name: 'Name',
      wrap: true,
      sortable: true,
      selector: item => item['Name'],
    },
    {
      name: 'Department',
      wrap: true,
      sortable: true,
      selector: item => item['Department'],
    },
    {
      name: 'Delete',
      wrap: true,
      cell: row => (
        <Button
          size="sm"
          variant="outline-danger"
          onClick={() => {
            set(ref(db, 'railway_notcollected/' + row.firebaseKey), null)
          }}
        >
          Delete
        </Button>
      ),
    },
  ]

  return (
    <div>
      <Navbars type={'1'} />
      <h1
        style={{
          color: '#636B65',
          marginTop: '5%',
          textAlign: 'center',
        }}
      >
        RAILWAY CONCESSION
      </h1>

      <h1>Pending Entries</h1>
      <InputGroup value={filterText1} onChange={e => setFilterText1(e.target.value)} className="mb-3">
        <InputGroup.Text id="inputGroup-sizing-default">Search for a pending entry</InputGroup.Text>
        <FormControl aria-label="Default" aria-describedby="inputGroup-sizing-default" />
      </InputGroup>
      <DataTable
        columns={pendingColumns}
        data={filteredPendingData}
        pagination
        paginationPerPage={5}
        paginationComponentOptions={{ noRowsPerPage: true }}
      />

      <Modal
        size="lg"
        show={JSON.stringify(modalEntry) !== '{}'}
        onHide={() => {
          setModalMessage('')
          setModalEntry({})
        }}
        aria-labelledby="example-modal-sizes-title-sm"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            Actions for {modalEntry.Name} (SAP: {modalEntry.SAP})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1">Recepient</InputGroup.Text>
            <FormControl disabled placeholder={modalEntry.Name} aria-label="Name" aria-describedby="basic-addon1" />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1">Message</InputGroup.Text>
            <FormControl
              value={modalMessage}
              onChange={event => setModalMessage(event.target.value)}
              aria-label="Message"
              aria-describedby="basic-addon1"
              as="textarea"
              rows="3"
            />
          </InputGroup>
          <div className="col-md-12 bg-light text-right">
            <Button
              onClick={() => {
                const { isEditingMessage, ...rest } = modalEntry
                const finalEntry = {
                  ...rest,
                  Message: modalMessage,
                }

                if (isEditingMessage) {
                  set(ref(db, 'railway_accepted/' + modalEntry.firebaseKey), finalEntry)
                    .then(() => {
                      console.log('Update the message')
                    })
                    .catch(err => {
                      console.log(err)
                    })
                  setModalMessage('')
                  setModalEntry({})
                  return
                }

                const actualModalSequence = modalEntry.SequenceNo ?? 0

                if (actualModalSequence) {
                  set(ref(db, 'Sequence/acceptedNo'), actualModalSequence).then(() => {
                    set(ref(db, 'railway_accepted/' + modalEntry.firebaseKey), finalEntry).then(() => {
                      set(ref(db, 'railway_pending/' + modalEntry.firebaseKey), null).then(() => {
                        set(ref(db, 'student_data/' + modalEntry.SAP + '/previous_date'), Date.now().toString()).catch(
                          err => {
                            console.log({ err })
                          }
                        )
                      })
                    })
                  })
                  return
                }

                set(ref(db, 'railway_accepted/' + modalEntry.firebaseKey), finalEntry).then(() => {
                  set(ref(db, 'railway_pending/' + modalEntry.firebaseKey), null).then(() => {
                    set(ref(db, 'student_data/' + modalEntry.SAP + '/previous_date'), Date.now().toString()).catch(
                      err => {
                        console.log({ err })
                      }
                    )
                  })
                })

                setModalMessage('')
                setModalEntry({})
              }}
              variant="success"
              disabled={modalMessage === '' ? true : false}
            >
              {modalEntry.isEditingMessage ? 'Update' : 'Accept'}
            </Button>
            {'   '}
            <Button
              onClick={() => {
                set(ref(db, 'railway_pending/' + modalEntry.firebaseKey), null)
                setModalMessage('')
                setModalEntry({})
              }}
              variant="danger"
              disabled={modalMessage === '' ? true : false}
            >
              Reject
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 1rem' }}>
        <h1>Accepted Entries</h1>
        <Button
          variant="primary"
          size="md"
          disabled={filteredAcceptedData?.length > 0 ? false : true}
          onClick={() => getAcceptedEntriesDataExcel(filteredAcceptedData)}
        >
          Extract Data
        </Button>
      </div>
      <InputGroup value={filterText2} onChange={e => setFilterText2(e.target.value)} className="mb-3">
        <InputGroup.Text id="inputGroup-sizing-default">Search for a pending entry</InputGroup.Text>
        <FormControl aria-label="Default" aria-describedby="inputGroup-sizing-default" />
      </InputGroup>
      <DataTable
        columns={acceptedColumns}
        data={filteredAcceptedData}
        pagination
        paginationPerPage={5}
        paginationComponentOptions={{ noRowsPerPage: true }}
      />

    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 1rem' }}>
        <h1>Not Collected Entries</h1>
        <div style={{display: 'flex'}}>
        <Button
          variant="primary"
          size="md"
          style={{ marginRight: '1rem' }}
          disabled={filteredNotCollectedData?.length > 0 ? false : true}
          onClick={() => getNotCollectedEntriesDataExcel(filteredNotCollectedData)}
        >
          Extract Data
        </Button>
        <FileUploader />
        </div>
      </div>
      <InputGroup value={filterText3} onChange={e => setFilterText3(e.target.value)} className="mb-3">
        <InputGroup.Text id="inputGroup-sizing-default">Search for a pending entry</InputGroup.Text>
        <FormControl aria-label="Default" aria-describedby="inputGroup-sizing-default" />
      </InputGroup>
      <DataTable
        columns={notCollectedColumns}
        data={filteredNotCollectedData}
        pagination
        paginationPerPage={5}
        paginationComponentOptions={{ noRowsPerPage: true }}
      />
    </div>
  )
}
export default RCAccept
